import React from 'react';
import { Link } from 'react-router-dom';
import NavyLogo from 'assets/images/NavyLogo.svg';

export default function WhiteHeader() {
    return (
        <Link style={styles.link} to={'/'}>
            <NavyLogo height={50} width={150} alt="tandem logo" />
        </Link>
    );
}

const styles = {
    link: {
        paddingLeft: 10,
    },
};
